module.exports = "pegasus/assets/tech/small/4.jpg";